// extracted by mini-css-extract-plugin
export default {"root":"Canvas_root__VxRhL"};